import { ROUTER_PROJECT_LIBRARY, ROUTER_WATCHLIST, ROUTER_QUESTIONAIRE, ROUTER_CARBON_ACCOUNT_MANAGEMENT_INSTITUTION, ROUTER_CARBON_ACCOUNT_MANAGEMENT_PROJECT_LOAN, ROUTER_CARBON_ACCOUNT_MANAGEMENT_NON_PROJECT_LOAN, ROUTER_CARBON_ACCOUNT_MANAGEMENT_EMISSION_SOURCE, ROUTER_STATISTICS_SCREEN, ROUTER_STATISTICS_REPORT, ROUTER_ENV_INFORMATION_DISCLOSURE, ROUTER_HOME, ROUTER_CORPORATE, ROUTER_CARBON_ACCOUNT_MANAGEMENT_TRADING, ROUTER_CARBON_ACCOUNT_MANAGEMENT_CONSUMPTION } from "constants/router";
import { css, injectGlobal } from "@emotion/css";
import { Dropdown } from "antd";
import { useHistory } from "react-router-dom";
import { DetailOutlinedIcon, EnergyOutlinedIcon, LeafOutlinedIcon, LinechartOutlinedIcon, ListOutlinedIcon, ReportOutlinedIcon, TransformOutlinedIcon } from "@miotech/prism";
import useRedux from "hooks/useRedux";
import { checkMenusPermission } from "utils/utils";


const contentStyle: React.CSSProperties = {
  top: '48px',
  borderRadius: '2px',
  border: '1px solid #526079',
  background: '#121927',
  boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.20)',
  padding: '16px',
};

const DropdownPanel = () => {
  const history = useHistory();
  const {
    selector: {
      resourceList,
    },
  } = useRedux(s => s.userRole);
  const navRoot = [
    {
      title: '绿色金融拓客',
      description: '高质量绿色企业及项目数据库，精准实现绿色金融营销设计及高效拓客。',
      icon: LeafOutlinedIcon,
      children: [
        {
          title: '企业库',
          path: ROUTER_HOME,
          process: checkMenusPermission(ROUTER_HOME, resourceList || []),
        },
        {
          title: '项目库',
          path: ROUTER_PROJECT_LIBRARY,
          process: checkMenusPermission(ROUTER_PROJECT_LIBRARY, resourceList || []),
        },
        {
          title: '客户名单管理',
          path: ROUTER_WATCHLIST,
          process: checkMenusPermission(ROUTER_WATCHLIST, resourceList || []),
        },
      ],
    },
    {
      title: '绿色信贷管理',
      description: '业界领先的AI智能识别模型实现快速精准的绿色信贷识别及打标。',
      icon: DetailOutlinedIcon,
      children: [
        {
          title: '对公信贷业务管理',
          path: ROUTER_CORPORATE,
          process: checkMenusPermission(ROUTER_CORPORATE, resourceList || []),
        },
        {
          title: '个人信贷业务管理',
          process: false,
          path: '',
        },
      ],
    },
    {
      title: '风险管理',
      description: '数字化ESG尽职调查及负面事件监测实现从贷前到贷后的全流程ESG风险评估、监控及预警。',
      icon: EnergyOutlinedIcon,
      children: [
        {
          title: 'ESG风险管理',
          path: ROUTER_QUESTIONAIRE,
          process: checkMenusPermission(ROUTER_QUESTIONAIRE, resourceList || []),
        },
      ],
    },
    {
      title: '碳核算管理',
      description: '科学的核算方法实现对公信贷业务碳排放量全覆盖和环境效益的精准测算;数字化管理金融机构自身运营碳排放数据，提升核算效率与准确性。',
      icon: TransformOutlinedIcon,
      children: [
        {
          title: '机构运营碳核算',
          path: ROUTER_CARBON_ACCOUNT_MANAGEMENT_INSTITUTION,
          process: checkMenusPermission(ROUTER_CARBON_ACCOUNT_MANAGEMENT_INSTITUTION, resourceList || []),
        },
        {
          title: '项目融资碳核算',
          path: ROUTER_CARBON_ACCOUNT_MANAGEMENT_PROJECT_LOAN,
          process: checkMenusPermission(ROUTER_CARBON_ACCOUNT_MANAGEMENT_PROJECT_LOAN, resourceList || []),
        },
        {
          title: '非项目融资碳核算',
          path: ROUTER_CARBON_ACCOUNT_MANAGEMENT_NON_PROJECT_LOAN,
          process: checkMenusPermission(ROUTER_CARBON_ACCOUNT_MANAGEMENT_NON_PROJECT_LOAN, resourceList || []),
        },
        {
          title: '贸易融资碳核算',
          path: ROUTER_CARBON_ACCOUNT_MANAGEMENT_TRADING,
          process: checkMenusPermission(ROUTER_CARBON_ACCOUNT_MANAGEMENT_TRADING, resourceList || []),
        },
        {
          title: '对公消费碳核算',
          path: ROUTER_CARBON_ACCOUNT_MANAGEMENT_CONSUMPTION,
          process: checkMenusPermission(ROUTER_CARBON_ACCOUNT_MANAGEMENT_CONSUMPTION, resourceList || []),
        },
        {
          title: '排放源设置',
          path: ROUTER_CARBON_ACCOUNT_MANAGEMENT_EMISSION_SOURCE,
          process: checkMenusPermission(ROUTER_CARBON_ACCOUNT_MANAGEMENT_EMISSION_SOURCE, resourceList || []),
        },
      ],
    },
    {
      title: '绿色金融业务统计',
      description: '实时汇总绿色金融业务数据，密切追踪绿色金融绩效达标情况。',
      icon: LinechartOutlinedIcon,
      children: [
        {
          title: '数据大屏',
          path: ROUTER_STATISTICS_SCREEN,
          process: checkMenusPermission(ROUTER_STATISTICS_SCREEN, resourceList || []),
        },
        {
          title: '监管报送',
          path: ROUTER_STATISTICS_REPORT,
          process: checkMenusPermission(ROUTER_STATISTICS_REPORT, resourceList || []),
        },
      ],
    },
    {
      title: '信息披露',
      description: '依据《金融机构环境信息披露指南》标准要求及TCFD框架，结合金融机构自身业务现状智能生成符合国际国内主流标准的披露报告。',
      icon: ReportOutlinedIcon,
      children: [
        {
          title: '环境信息披露',
          path: ROUTER_ENV_INFORMATION_DISCLOSURE,
          process: checkMenusPermission(ROUTER_ENV_INFORMATION_DISCLOSURE, resourceList || []),
        }
      ],
    },
  ];
  return <div className={DropdownStyle}>
    <Dropdown
      overlayStyle={{ top: '48px', width: 'auto' }}
      getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
      dropdownRender={() => {
        return <div style={contentStyle}>
          <div className="dropdown-menu-panel">
            {
              navRoot.map((item) => {
                return <div key={item.title} className="dropdown-menu-panel-item">
                  <div className="dropdown-menu-panel-item-title">
                    <item.icon />
                    {item.title}
                  </div>
                  <div className="dropdown-menu-panel-item-children">
                    {
                      item.children && item.children.map((child) => {
                        return <div
                          key={child.title}
                          data-process={child.process}
                          className="dropdown-menu-panel-item-children-item"
                          onClick={() => {
                            if (child.process) {
                              history.push(child.path);
                            }
                          }}
                        >
                          {child.title}
                        </div>;
                      })
                    }
                  </div>
                </div>;
              })
            }
          </div>
        </div>;
      }}
    >
      <div className="dropdown">
        <ListOutlinedIcon />
        功能列表
      </div>
    </Dropdown>
  </div>;
};

export default DropdownPanel;
injectGlobal`
  .dropdown-menu-panel {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(auto-fit, minmax(min-content, 1fr));
    gap: 16px 40px;
    color: #fff;
    .dropdown-menu-panel-item {

    }
    .dropdown-menu-panel-item-children {
      margin-top: 8px;
      .dropdown-menu-panel-item-children-item {
        cursor: pointer;
        padding: 8px;
        border-radius: 2px;
        height: 28px;
        color: #E7E7E7;
        font-family: "PingFang SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px;
        &[data-process="false"] {
          cursor: not-allowed;
          opacity: 0.7;
        }
        &:not([data-process="false"]) {
          cursor: pointer;
          &:hover {
            background: #1E2534;
          }
        }
      }
    }
    .dropdown-menu-panel-item-title {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      gap: 6px;
      min-width: 196px;
      padding: 6px 8px;
      color: #B3C6D8;
      font-family: "PingFang SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      border-bottom: .5px solid #06C27F;
    }
  }
`;
const DropdownStyle = css`
  position: relative;
  .dropdown {
    height: 100%;
    color: #fff;
    background: rgba(6, 194, 127, 0.80);
    height: 48px;
    padding: 8px 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    color: #e7e7e7;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
  }
`;
